import { AloBase, getDefaultAloBase } from './AloBase'
import {ExportCatalogType} from '@/enum/ExportCatalogType'

export interface AloMeta extends AloBase {    
    newId:number  
    dsoId:number    
    mtgId:number 
    mtaKey:string
    mtaPos:number
    mtaFluxTyp:ExportCatalogType
    mtaDisabled:boolean    
    mtaIsDefault:boolean
    mtaIsDirect:boolean
    mtaDbname:string
    mtaEncapsulation:string
    mtaDesc:string    
    mtaConfigJson:string
    enseignesIds:Array<number>

}

export const getDefaultAloMeta = ():AloMeta => {
    return {
        ...getDefaultAloBase(),
        newId:0,
        dsoId:0,   
        mtgId:0,
        mtaKey:'',
        mtaPos:0,
        mtaFluxTyp:ExportCatalogType.Offers,
        mtaDisabled:false,
        mtaIsDefault:false,
        mtaIsDirect:false,
        mtaDbname:'',
        mtaEncapsulation:'cdata',
        mtaDesc:'',
        mtaConfigJson:'{}',
        enseignesIds:[],
    }
}

export const cleanAloMeta = (meta:AloMeta) => {
    if(!meta) return    
    if(!meta.dsoId) delete meta.dsoId
    if(!meta.mtgId) delete meta.mtgId
    if(!meta.id) delete meta.id
}
